<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header -->
  <div class="mb-8">
    <div class="flex items-center gap-3 mb-2">
      <div class="p-2 bg-gray-800 rounded-lg">
        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Configuración del Sistema</h1>
        <p class="text-gray-500 text-sm">Administra todas las configuraciones y ajustes de la plataforma</p>
      </div>
    </div>
  </div>

  <!-- Categories Grid -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <ng-container *ngFor="let category of categories">
      <div *ngIf="canShowCategory(category)" 
           class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        
        <!-- Category Header -->
        <div class="px-5 py-4 border-b" [ngClass]="getColorClasses(category.color, 'border')">
          <div class="flex items-center gap-3">
            <div class="p-2 rounded-lg" [ngClass]="getColorClasses(category.color, 'bg')">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="category.icon" />
              </svg>
            </div>
            <h2 class="text-lg font-semibold text-gray-800">{{ category.name }}</h2>
          </div>
        </div>

        <!-- Category Items -->
        <div class="divide-y divide-gray-100">
          <ng-container *ngFor="let item of category.items">
            <a *ngIf="canShowItem(item)"
               [routerLink]="item.route"
               class="flex items-center gap-4 px-5 py-4 transition-colors group"
               [ngClass]="[getColorClasses(item.color, 'hover'), item.danger ? 'hover:bg-red-50' : '']">
              
              <!-- Item Icon -->
              <div class="flex-shrink-0 p-2 rounded-lg transition-colors"
                   [ngClass]="item.danger ? 'bg-red-100 text-red-600 group-hover:bg-red-200' : 'bg-gray-100 group-hover:bg-gray-200 ' + getColorClasses(item.color, 'text')">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon" />
                </svg>
              </div>

              <!-- Item Content -->
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2">
                  <h3 class="text-sm font-medium text-gray-800 group-hover:text-gray-900"
                      [ngClass]="item.danger ? 'text-red-700' : ''">
                    {{ item.name }}
                  </h3>
                  <span *ngIf="item.superAdminOnly" 
                        class="px-2 py-0.5 text-xs font-medium bg-purple-100 text-purple-700 rounded-full">
                    SuperAdmin
                  </span>
                  <span *ngIf="item.danger" 
                        class="px-2 py-0.5 text-xs font-medium bg-red-100 text-red-700 rounded-full">
                    Peligro
                  </span>
                </div>
                <p class="text-xs text-gray-500 truncate">{{ item.description }}</p>
              </div>

              <!-- Arrow Icon -->
              <div class="flex-shrink-0 text-gray-400 group-hover:text-gray-600 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </a>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Quick Info Card -->
  <div class="mt-8 bg-gradient-to-r from-gray-800 to-gray-700 rounded-xl p-6 text-white">
    <div class="flex items-start gap-4">
      <div class="p-3 bg-white/10 rounded-lg">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div>
        <h3 class="text-lg font-semibold mb-1">Acerca de la Configuración</h3>
        <p class="text-gray-300 text-sm leading-relaxed">
          Desde este panel puedes administrar todos los aspectos del sistema financiero. 
          Los cambios en configuración pueden afectar el comportamiento de la aplicación. 
          Si tienes dudas sobre alguna opción, consulta la documentación o contacta al administrador.
        </p>
      </div>
    </div>
  </div>
</div>

